import o from "./_baseClone.js";
var r = 1, n = 4;
function L(e) {
  return o(e, r | n);
}
export {
  L as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/cloneDeep.js
// module id = 924
// module chunks = 67